import React from 'react';

import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function Languages({ member }) {
  return (
    <>
      {member.languages.map((lang) => (
        <IconWithText
          key={lang.id}
          iconClassName="small-icon picture-icon"
          iconStyle={{
            backgroundImage: `url(${lang.flag})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
          wrapperClassName="mt-3"
        >
          {lang.title}
        </IconWithText>
      ))}
    </>
  );
}

Languages.propTypes = {
  member: PropTypes.object.isRequired,
};
